import { cloneDeep } from '@apollo/client/utilities';
import { CompanyEntity, forCreate, forDelete, forUpdate } from '../common/entity';
import { EntityType } from '../comment';
import { CompanyRole } from '../company_role_assignment';

export class TagRelation extends CompanyEntity {
  entityId!: string;
  tagId!: string;
  type!: EntityType;

  authorization: TagRelationAuthorization = new TagRelationAuthorization();

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, cloneDeep(obj));
  }

  forCreate(): CreateTagRelationInput {
    delete (this as any).authorization;
    return CreateTagRelationInput.from(this, CreateTagRelationInput);
  }

  forUpdate(): UpdateTagRelationInput {
    return UpdateTagRelationInput.from(this, UpdateTagRelationInput);
  }

  forDelete(): DeleteTagRelationInput {
    delete (this as any).authorization;
    return DeleteTagRelationInput.from(this, DeleteTagRelationInput);
  }

  validate(fields: (keyof TagRelation)[]) {
    return this.validateEntity(fields, field => {
      return null;
    });
  }

  withEntityId(entityId: string) {
    this.entityId = entityId;
    return cloneDeep(this);
  }

  withTagId(tagId: string) {
    this.tagId = tagId;
    return cloneDeep(this);
  }

  withType(type: EntityType) {
    this.type = type;
    return cloneDeep(this);
  }
}

export class CreateTagRelationInput extends forCreate(TagRelation) {}
export class UpdateTagRelationInput extends forUpdate(TagRelation) {}
export class DeleteTagRelationInput extends forDelete(TagRelation) {}

export class TagRelationAuthorization {
  forCreate = () => CompanyRole.administrator;
  forUpdate = () => CompanyRole.administrator;
  forDelete = () => CompanyRole.administrator;
  forGet = () => CompanyRole.employee;
}
